import React from "react";
import {CustomerFluidSubPageLayout} from "../../layouts/customerLayout/customerFluidSubPageLayout/CustomerFluidSubPageLayout";
import {useObserver} from "mobx-react-lite";
import {SubCompanyPaymentContractList} from "../../company/subCompanyDetail/subCompanyPaymentContracts/SubCompanyPaymentContractList";
import {useStore} from "../../../hooks/useStore";
import {CustomerMenuHeader} from "components/layouts/customerLayout/components/customerMenuHeader";

export const CustomerContractPage = () => {
    const stores = useStore();
    const subCompanyId = stores?.meStore?.subcompanies?.[0]?._id;

    return useObserver(() => (
        <CustomerFluidSubPageLayout pageTitle="Sözleşme">
            <CustomerMenuHeader />
            {subCompanyId && <SubCompanyPaymentContractList subCompanyId={subCompanyId} />}
        </CustomerFluidSubPageLayout>
    ));
};

export default CustomerContractPage;
